module.exports = __webpack_public_path__ + "static/media/schody52 - schody drewniane czarne z oswietleniem pod stopniami.9afc70a7.jpg";